/**
 * @fileoverview controller for removed review settings
 *
 * @author pterry@yext.com
 */
goog.module('yext.storm.RemovedReviewSettingsView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const IndividualComplianceSettingView = goog.require('yext.storm.IndividualComplianceSettingView');
const routes = goog.require('yext.storm.routes');

/**
 * @constructor
 * @extends {IndividualComplianceSettingView}
 */
const RemovedReviewSettingsView = function() {
  /** @type {!jQuery} */
  this.$el = $('.js-removed-review-settings-field');

  IndividualComplianceSettingView.call(this);
};
goog.inherits(RemovedReviewSettingsView, IndividualComplianceSettingView);

/** @enum */
RemovedReviewSettingsView.Mode = {
  REMAIN_IN_PLATFORM: 0,
  PURGE: 1,
};

/** @override */
RemovedReviewSettingsView.prototype.doAdditionalBinding = function() {
  this.bindInputToModel_();
  this.resetInput();
};

/** @override */
RemovedReviewSettingsView.prototype.getAdditionalModelProperties = function() {
  return {
    'selectedOption': this.$el.data('option'),
  };
};

/** @private */
RemovedReviewSettingsView.prototype.bindInputToModel_ = function() {
  this.$el.find('.js-setting-option').inputchange(function(e) {
    let selectedOption = parseInt(this.$el.find('.js-setting-option:checked').val(), 10);
    this.model.set('selectedOption', selectedOption);
  }.bind(this));
};

/** @override */
RemovedReviewSettingsView.prototype.resetInput = function() {
  let shouldPurge = this.model.get('selectedOption') ==
    RemovedReviewSettingsView.Mode.PURGE;
  document.getElementById('remain').checked = !shouldPurge;
  document.getElementById('purge').checked = shouldPurge;
};

/**
 * @override
 * @suppress {deprecated}
 */
RemovedReviewSettingsView.prototype.bindSubmit = function() {
  var $confirmationDialog = this.$el.find('.js-confirm-purge-dialog');
  $confirmationDialog.dialog({
    title: yext.msg('Delete Removed Reviews?'),
    modal: true,
    draggable: false,
    resizable: false,
    autoOpen: false,
    width: 355,
    minHeight: 0,
  });
  $confirmationDialog.on('click', '.js-dialog-cancel', function() {
    $confirmationDialog.dialog('close');
  });
  $confirmationDialog.on('submit', function(e) {
    e.preventDefault();
    this.callSubmitUrl();
    $confirmationDialog.dialog('close');
  }.bind(this));

  this.$el.find('form').on('submit', function(e) {
    e.stopPropagation();
    e.preventDefault();
    let selectedOption = this.model.get('selectedOption');
    if (selectedOption == RemovedReviewSettingsView.Mode.REMAIN_IN_PLATFORM) {
      this.callSubmitUrl();
    } else {
      $confirmationDialog.dialog('open');
    }
  }.bind(this));
};

/** @override */
RemovedReviewSettingsView.prototype.getSubmitUrl = function() {
  return routes.AccountSettings.updateRemovedReviewSettings();
};

/** @override */
RemovedReviewSettingsView.prototype.getData = function() {
  return {'selectedOptionOrdinal': this.model.get('selectedOption')};
};

/** @override */
RemovedReviewSettingsView.prototype.renderDisplay = function() {
  let option = this.model.get('selectedOption');

  if (option == RemovedReviewSettingsView.Mode.REMAIN_IN_PLATFORM) {
    this.$viewMode.html(
      yext.msg('Removed Reviews Remain in Platform') +
      '<br/><div class="removed-reviews-gdpr-warning icon-status-warning">' +
        yext.msg('If an entity is subject to GDPR, removed reviews on that entity will always be' +
                 ' deleted from the platform immediately.') +
      '</div>');
  } else if (option = RemovedReviewSettingsView.Mode.PURGE) {
    this.$viewMode.html(yext.msg('Removed Reviews are Deleted From Platform'));
  }
};

exports = RemovedReviewSettingsView;
